import { render, staticRenderFns } from "./AuditClaimsTable.vue?vue&type=template&id=4aae7226&scoped=true"
import script from "./AuditClaimsTable.vue?vue&type=script&lang=js"
export * from "./AuditClaimsTable.vue?vue&type=script&lang=js"
import style0 from "./AuditClaimsTable.vue?vue&type=style&index=0&id=4aae7226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae7226",
  null
  
)

export default component.exports